(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequently-asked-question-state-history', {
            parent: 'entity',
            url: '/frequently-asked-question-state-history?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestionStateHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-histories.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestionStateHistory');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequently-asked-question-state-history-detail', {
            parent: 'frequently-asked-question-state-history',
            url: '/frequently-asked-question-state-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestionStateHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-detail.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestionStateHistory');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FrequentlyAskedQuestionStateHistory', function($stateParams, FrequentlyAskedQuestionStateHistory) {
                    return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'frequently-asked-question-state-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('frequently-asked-question-state-history-detail.edit', {
            parent: 'frequently-asked-question-state-history-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question-state-history.new', {
            parent: 'frequently-asked-question-state-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateSetTimestamp: null,
                                faqStateOld: null,
                                faqStateNew: null,
                                info: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('frequently-asked-question-state-history');
                });
            }]
        })
        .state('frequently-asked-question-state-history.edit', {
            parent: 'frequently-asked-question-state-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question-state-history.delete', {
            parent: 'frequently-asked-question-state-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-delete-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
